import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/locked-scene.webp")